module.exports = __webpack_public_path__ + "img/7_18.9cc4ab11.png";